<template>
<div>
    <!-- <p class="tasks">Completed Tasks: {{todos.filter(todo => {return todo.done === true}).length}}</p>
    <p class="tasks">Pending Tasks: {{todos.filter(todo => {return todo.done === false}).length}}</p> -->
    <data-view v-on:delete-data="deleteData" v-on:complete-data="completeData" v-on:update-data="updateData" v-for="data in dataList" :data="data" v-bind:key="data.key"></data-view>
</div>
</template>

<script>

import VueSweetalert2 from 'vue-sweetalert2';
import DataView from '../Kelas/DataView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
                level: '',
                name: '',
                status: 1
            },
            teachers: '',
            result: "",
            errors: []
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    methods: {
        deleteData(data) {

            // Use sweetalert2
            this.$swal({
                title: "Are you sure? ",
                text: "Class " + data.level + " " + data.name + " and ALL STUDENTS UNDER IT will be permanently deleted!  To continue, enter 'DELETE' in the text field below and press OK",
                input: 'text',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value == "DELETE"){
                        this.input.email = localStorage.getItem('email')
                        this.input.sessionID = localStorage.getItem('sessionID')
                        this.input.dataID = data._id

                        console.log("48 before dataIndex")
                        const dataIndex = this.dataList.indexOf(data);
                        this.dataList.splice(dataIndex, 1);

                        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/api/auth/kelas/remove', this.input)
                            .then(response => {
                                console.log("imini 44")
                                console.log("imini response: ")
                                console.log(response)

                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                } else {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                }
                            })
                            .catch(e => {
                                console.log(e.response)
                                if (e.response.status === 401) {
                                    console.log("salah login")
                                    this.errors.push("Invalid login")
                                    Toast.open({
                                        message: "Unauthorized access. Please re-login.",
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                } else {
                                    this.errors.push(e)
                                    Toast.open({
                                        message: e,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                }
                            })
                    }else{
                        alert("You entered the wrong input. Class is not removed.")
                    }
                    //return !value && 'You need to write something!'
                }
            });
        },
        completeData(data) {
            console.log("100 completeData")
            const dataIndex = this.dataList.indexOf(data);
            this.dataList[dataIndex].done = true;
            sweetalert('Success!', 'Kelas completed!', 'success');
        },

        updateData(data) {
            if (data.level.length > 0 && data.name.length > 0) {

                console.log("imini 83")

                this.input.email = localStorage.getItem('email')
                this.input.sessionID = localStorage.getItem('sessionID')
                this.input._id = data._id
                this.input.level = data.level
                this.input.name = data.name
                this.input.status = data.status
                this.input.teachers = data.teachers

                //alert("id: " + kelas._id + " name: " + kelas.name)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.post(process.env.MY_URL + '/api/auth/kelas/update', this.input)
                    .then(response => {
                        if (response.status === 200){
                            Toast.open({
                                message: 'Successfully updated the class',
                                type: 'is-success', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                        }else{
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                            this.errors.push(e)
                        }
                    })

            } else {
                alert("Please enter the level and name");
            }
        },
    },
};
</script>

<style scoped>
p.tasks {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Database/Kelas/DataList.vue